// /employee/login — Path B entry. Sales enters their @argoshipping.com
// email; we POST it to /api/employee/login/start which (a) checks the
// domain allow-list, (b) calls Nexus to verify the email is a
// TenantUser with the impersonation privilege, (c) sends a magic link.
//
// Anti-enumeration: the backend always returns 202 regardless of
// outcome. The SPA's copy reflects this — "if your email is authorized
// we sent you a link." No tell-back about whether the address was
// recognized.

import { useState } from 'react';

import * as imp from '../api/impersonation.js';

export function EmployeeLogin(): JSX.Element {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  if (sent) {
    return (
      <div className="card">
        <h2>Check your email</h2>
        <p>
          If <strong>{email}</strong> is an authorized Argo employee account, we sent a sign-in link.
        </p>
        <p>
          Open the email and click the link to continue. The link expires in 10 minutes.
        </p>
        <p style={{ marginTop: 16 }}>
          <button
            type="button"
            onClick={() => {
              setSent(false);
              setEmail('');
            }}
          >
            Use a different address
          </button>
        </p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2>Argo employee sign-in</h2>
      <p style={{ color: 'var(--color-text-muted)' }}>
        Enter your Argo email to receive a one-time sign-in link. Available only to ERP-authorized employees.
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setSubmitting(true);
          void (async () => {
            try {
              await imp.startEmployeeLogin(email);
            } finally {
              setSubmitting(false);
              setSent(true);
            }
          })();
        }}
      >
        <div className="form-row">
          <label htmlFor="email">Argo email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@argoshipping.com"
          />
        </div>
        <button className="primary" type="submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send sign-in link'}
        </button>
      </form>
    </div>
  );
}
